import * as Sentry from '@sentry/react';
import { stopRecorder } from 'features/recorder/utils';
import { selectRoomToken } from 'features/room/roomSlice';
import { RoomToken } from 'features/room/types';
import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';

// Sentry, not logs: a death that closed signaling first has no delivery channel left.
const capture = (error: unknown) =>
  Sentry.captureException(error, { tags: { feature: 'recorder' } });

export function* terminateRecorderSessionSaga() {
  const token: RoomToken = yield select(selectRoomToken);
  const recordingId = token.parsedData?.recordingId;

  if (recordingId) {
    // Not awaited: a wedged extension would block the failure report below,
    // which is worth far more than the in-flight chunk this call saves.
    try {
      stopRecorder({ recordingId }).catch(capture);
    } catch (error) {
      capture(error);
    }
  }

  // The backend releases its reference to the recording allocation while handling
  // the report, and a log batch arriving after that has no recording id to be filed
  // under. Getting the tail onto the wire first is what keeps it addressable.
  logger.flush();

  const isReportDelivered: boolean = yield call(SignalingSocket.send, {
    event: 'recordingFailure',
  });

  // A death that closed signaling first (janus_error) leaves the backend with
  // nothing, so the silence itself has to be reported.
  if (!isReportDelivered) {
    capture(new Error('Recorder failure report dropped: signaling socket already closed'));
  }

  yield call(SignalingSocket.close, undefined, 'recorder_fatal_error');
}
